import React, { useState, useEffect } from 'react';
import { compose, withStylesLoaded } from '@concur/core-ui-shell';
import MiniHeader from './_MiniHeader';
import FallbackComponent from '../FallbackComponent/_FallbackComponent';
import withNuiIntl from '../utils/withNuiIntl';
import withStylesPlaceholder from '../utils/withStylesPlaceholder';
import { getCacheKey } from '../utils/sessionStorageUtils';

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppMiniHeader = (props) => {
    const {
        brandingLogo,
        configOptions,
        oshCacheIdentifier,
        ...otherProps
    } = props;

    const fallbackComp = (errorId) => (
        <FallbackComponent
            componentCssBlock={MiniHeader.cssBlock}
            correlationId={errorId}
        />
    );

    const [cdsData, setCdsData] = useState();
    const cacheKey = getCacheKey(oshCacheIdentifier);

    useEffect(() => {
        const existingSessionData = window.sessionStorage
            && JSON.parse(window.sessionStorage.getItem(cacheKey));
        if (existingSessionData) {
            setCdsData(existingSessionData);
        }
    }, []);

    return (
        <MiniHeader
            {...otherProps}
            brandingLogo={cdsData?.brandingLogo || brandingLogo}
            configOptions={configOptions}
            errorComp={fallbackComp}
            oshCacheIdentifier={oshCacheIdentifier}
        />
    );
};

AppMiniHeader.displayName = 'AppMiniHeader';

AppMiniHeader.propTypes = {
    ...MiniHeader.propTypes,
};

export default compose(
    withStylesPlaceholder,
    withStylesLoaded,
    withNuiIntl,
)(AppMiniHeader);
